<template>
  <div class="dialog-con">
    <div class="container">
      <div class="content">
        <div v-if="showClose" @click="close">
          <svg-icon icon-class="close"></svg-icon>
        </div>
        <slot></slot>
      </div>
      <slot name="bottomBtn">
        <div v-if="hasBtnGroup" class="btn-group">
          <div class="btn1" @click="btn1Click">{{ btn1Text }}</div>
          <slot name="btn2">
            <div class="btn2" @click="btn2Click">{{ btn2Text }}</div>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Dialog",
    props: {
      showClose: {
        type: Boolean,
        default: true
      },
      hasBtnGroup: {
        type: Boolean,
        default: false
      },
      btn1Text: {
        type: String,
        default: '取消'
      },
      btn2Text: {
        type: String,
        default: '确定'
      }
    },
    methods: {
      close() {
        this.$emit('close')
      },
      btn1Click() {
        this.$emit('btn1Fun')
      },
      btn2Click() {
        this.$emit('btn2Fun')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-con {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(0, 0, 0, .7);
    color: #000;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;

    .container {
      background-color: #fff;
      text-align: center;
      border-radius: 30px;
    }

    .content {
      padding: 70px;
      position: relative;

      .svg-icon {
        position: absolute;
        right: 40px;
        top: 40px;

        fill: #ccc;
      }
    }

    .btn-group {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-top: 1px solid #f2f2f2;

      div {
        width: 50%;
        padding: 30px 0;

        &:nth-child(2) {
          color: #5f6e9a;
        }
      }

      .btn1 {
        border-right: 1px solid #f2f2f2;
      }
    }
  }
</style>